module.exports = __webpack_public_path__ + "img/tabbed-search-filter-mitsu.dedad3d0.png";